import { Component, Input } from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import { Option } from "@recore-solutions/nstar-lib";

@Component({
	selector: "app-listing-timeframe-select",
	templateUrl: "./listing-timeframe-select.component.html",
	styleUrls: ["./listing-timeframe-select.component.scss"],
})
export class ListingTimeframeSelectComponent {
	@Input() control: UntypedFormControl;

	whenOptions: Option[] = [
		{ value: "Last 30 days", key: "30:days::0:days", sortOrder: 1 },
		{ value: "Last 90 days", key: "90:days::0:days", sortOrder: 1 },
		{ value: "Last 6 months", key: "6:months::0:days", sortOrder: 1 },
		{ value: "Last 12 months", key: "12:months::0:days", sortOrder: 1 },
		{ value: "Any time", key: "100:years::0:days", sortOrder: 1 },
	];

	constructor() {}
}
